import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

import MenuBar from "./components/MenuBar/MenuBar";
import Footer from "./components/Footer/Footer";
import HomePage from "./pages/HomePage/HomePage";
import MenuPage from "./pages/MenuPage/MenuPage";
import MenuPageRestaurant from "./pages/MenuPageRestaurant/MenuPageRestaurant";
import ContactPage from "./pages/ContactPage/ContactPage";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import TermsPage from "./pages/LegalPage/TermsPage";
import PrivacyPage from "./pages/LegalPage/PrivacyPage";
import CookiesPage from "./pages/LegalPage/CookiesPage";
import CookieBanner from "./pages/LegalPage/CookieBanner";
import LandingPage from "./pages/LandingPage/LandingPage";

import { GlobalStyle } from "./GlobalStyle";
import BackToLandingButton from "./components/BackToLandingButton/BackToLandingButton";

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const isLanding = location.pathname === "/";

  return (
    <>
      {!isLanding && <MenuBar />}
      {children}
      {!isLanding && <BackToLandingButton />}
      {!isLanding && <Footer />}
      {isLanding && <CookieBanner />}
    </>
  );
};

const App: React.FC = () => {
  return (
    // 👇 HelmetProvider trebuie să fie în jurul întregii aplicații
    <HelmetProvider>
      <Router>
        <GlobalStyle />
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/acasa" element={<HomePage />} />
            <Route path="/meniu_restaurant/" element={<MenuPageRestaurant />} />
            <Route path="/meniu_delivery/" element={<MenuPage />} />
            <Route path="/restaurant/" element={<HomePage />} />
            <Route path="/contact/" element={<ContactPage />} />
            <Route path="/despre_noi/" element={<AboutUsPage />} />
            <Route path="/termeni" element={<TermsPage />} />
            <Route path="/politica" element={<PrivacyPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
          </Routes>
        </Layout>
        <CookieBanner />
      </Router>
    </HelmetProvider>
  );
};

export default App;
